<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Cuadro de mandos</f7-nav-title>
    </f7-navbar>
    <div class="sello-datos-bar"><sello-datos estado="vivo" /></div>
    <div class="dashboard-grid">
      <f7-link v-roles="['ADMIN','DIRECTOR','DTYCAL','COMERCIAL']" href="/dashboard/oea/" class="dashboard-card active" style="border-left: 4px solid #0F6E56">
        <div class="card-icon" style="background: #E1F5EE">
          <f7-icon f7="chart_bar_fill" style="color: #0F6E56; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">OEA</p>
        <p class="card-subtitle">Contratación</p>
      </f7-link>
      <f7-link v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']" href="/dashboard/oeb/" class="dashboard-card active" style="border-left: 4px solid #185FA5">
        <div class="card-icon" style="background: #E6F1FB">
          <f7-icon f7="hammer_fill" style="color: #185FA5; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">OEB</p>
        <p class="card-subtitle">Producción</p>
      </f7-link>
      <!-- FACT-COBRO (#167) · la pestaña FACTURACIÓN: sustituye la hoja de cálculo «EVOLUCIÓN DE LA
           FACTURACIÓN Y DEL COBRO» que dirección llevaba a mano desde 2020. La crea F3 (#171), que
           es la primera fase que llega a pantalla; F2 (#170) añade la Tarjeta A dentro.

           La entrada es de ADMIN y DIRECTOR y de nadie más (D-ROL). El `v-if` y la ruta contestan a
           la MISMA pregunta (`permisos-facturacion.js`) y con el MISMO usuario —el que ha traído
           `Usuario.me()` en esta carga—, para que no puedan decir cosas distintas, y las dos son
           fail-closed. Detrás, el 403 de la API.

           NO es ninguno de los OEx de abajo: aquella serie son los objetivos estratégicos y esta
           pestaña cruza facturación y cobro, así que OED y OEE se quedan como estaban. -->
      <f7-link v-if="puedeVerFacturacion" href="/dashboard/facturacion/" class="dashboard-card active" style="border-left: 4px solid #BA7517">
        <div class="card-icon" style="background: #FAEEDA">
          <f7-icon f7="chart_bar_alt_fill" style="color: #BA7517; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">FACTURACIÓN</p>
        <p class="card-subtitle">Facturación y cobro real</p>
      </f7-link>
      <!-- Registro de gastos (2026-10): la tarjeta deja de estar en gris y abre el listado de gastos
           (cada cual ve los suyos; ADMIN, ADMINISTRACION y DIRECTOR, los de cualquier persona).
           Se enseña con el mismo criterio que deja pasar la ruta (`/gastos/` en el menú de Mongo
           del usuario de ESTA carga): si no, pincharla llevaría al 403. -->
      <f7-link v-if="puedeVerGastos" href="/gastos/" class="dashboard-card active" style="border-left: 4px solid #D85A30">
        <div class="card-icon" style="background: #FAECE7">
          <f7-icon f7="money_euro_circle_fill" style="color: #D85A30; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">OEC</p>
        <p class="card-subtitle">Gastos con foto del ticket</p>
      </f7-link>
      <!-- GASTOS-1 (#1080) · OEC GASTOS sobre Business Central: en gris hasta que exista su primera
           pantalla (incidencias GASTOS- posteriores). No es la OEC de arriba, que es el registro de
           gastos con foto del ticket y va por su lado. Sin ruta no hay entrada en el menú de Mongo,
           así que se filtra por rol (`v-roles`, que no pregunta al servidor). La línea de debajo de
           la insignia es la regla de pantalla de dirección: en gris, pero diciendo por qué y quién. -->
      <div v-roles="['ADMIN','DIRECTOR']" class="dashboard-card disabled" style="border-left: 4px solid #993556">
        <div class="card-icon" style="background: #FBEAF0">
          <f7-icon f7="doc_chart_fill" style="color: #993556; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">OEC GASTOS</p>
        <p class="card-subtitle">Business Central</p>
        <p class="card-badge">Próximamente</p>
        <p class="card-motivo">En construcción: gestión del gasto sobre Business Central · Dirección</p>
      </div>
      <!-- GASTOS-1b (#1085) · PRESUPUESTOS, TESORERÍA y SALDOS BANCARIOS: mismo patrón que OEC GASTOS
           y por lo mismo (sin ruta todavía, así que sin menú de Mongo y filtradas por rol). Son
           tarjetas propias y no parte de OEE, por decisión de dirección del 29/10/2026 (#927). -->
      <div v-roles="['ADMIN','DIRECTOR']" class="dashboard-card disabled" style="border-left: 4px solid #3B6D11">
        <div class="card-icon" style="background: #EAF3DE">
          <f7-icon f7="flag_fill" style="color: #3B6D11; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">PRESUPUESTOS</p>
        <p class="card-subtitle">Presupuesto y objetivos</p>
        <p class="card-badge">Próximamente</p>
        <p class="card-motivo">En construcción: presupuesto 2027 y objetivos de resultado, EBIT y EBITDA · Dirección</p>
      </div>
      <div v-roles="['ADMIN','DIRECTOR']" class="dashboard-card disabled" style="border-left: 4px solid #0E7490">
        <div class="card-icon" style="background: #E0F2F7">
          <f7-icon f7="graph_square" style="color: #0E7490; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">TESORERÍA</p>
        <p class="card-subtitle">Previsión de caja</p>
        <p class="card-badge">Próximamente</p>
        <p class="card-motivo">En construcción: previsión a 13 semanas y 12 meses · Dirección</p>
      </div>
      <div v-roles="['ADMIN','DIRECTOR']" class="dashboard-card disabled" style="border-left: 4px solid #A32D2D">
        <div class="card-icon" style="background: #FCEBEB">
          <f7-icon f7="equal_square" style="color: #A32D2D; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">SALDOS BANCARIOS</p>
        <p class="card-subtitle">Saldo de cada cuenta</p>
        <p class="card-badge">Próximamente</p>
        <p class="card-motivo">En construcción: saldo diario de las cuentas de BC · Dirección</p>
      </div>
      <!-- FACT-COBRO · COB-1 (#187) · la tarjeta OED · Cobros DEJA DE ESTAR EN GRIS. Hasta ahora
           decía «Próximamente», no enseñaba cifra y no abría nada; ahora enseña el pendiente de la
           cartera y abre el Centro de Cobros. Es la puerta de todo el programa Centro de Cobros.

           La cifra NO se calcula aquí: es la misma que la tarjeta «Pendiente total» de esa
           pantalla, pedida al mismo cálculo del servidor (D-COB-11, «se reutiliza, no se
           duplica»). Y viene recortada por permisos igual que la pantalla: si aquí se enseñara la
           cartera de la empresa y al entrar apareciera otra cifra, la tarjeta estaría mintiendo.

           Quién la ve: `permisos-cobros.js`, que NO es la lista de la pestaña FACTURACIÓN. Aquí
           D-COB-5 recorta en vez de negar, así que el comercial —para quien la pantalla está
           hecha— entra. El `v-if` y la ruta preguntan lo mismo con el mismo usuario.

           La tarjeta FACTURACIÓN y su cálculo no se tocan: esto solo añade. -->
      <f7-link v-if="puedeVerCobros" href="/dashboard/cobros/" class="dashboard-card active" style="border-left: 4px solid #534AB7">
        <div class="card-icon" style="background: #EEEDFE">
          <f7-icon f7="creditcard_fill" style="color: #534AB7; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">OED</p>
        <p class="card-subtitle">Cobros</p>
        <p class="card-cifra" v-if="pendienteCobros !== null">{{ pendienteCobros }} €</p>
        <p class="card-badge" v-if="pendienteCobros !== null && documentosCobros !== null">
          {{ documentosCobros }} documentos pendientes
        </p>
        <!-- Sin cifra no se escribe un cero: la pantalla se abre igual y allí se dice qué pasa. -->
        <p class="card-badge" v-if="pendienteCobros === null">Ver la cartera</p>
      </f7-link>
      <div v-else class="dashboard-card disabled" style="border-left: 4px solid #534AB7">
        <div class="card-icon" style="background: #EEEDFE">
          <f7-icon f7="creditcard_fill" style="color: #534AB7; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">OED</p>
        <p class="card-subtitle">Cobros</p>
      </div>
      <!-- FACT-COBRO · COB-4 (#190) · LA PUERTA A «MI TRABAJO DE HOY» PARA QUIEN NO TIENE OTRA.

           Esta tarjeta existe por un hueco concreto, no por simetría. «Gestor de cobro» no es un
           rol: es quien figura como PGC en alguna factura (D-COB-3), así que puede haber un gestor
           con cartera y sin ninguno de los roles de `permisos-cobros.js`. A esa persona el servidor
           la deja entrar en su lista diaria (criterio 10) pero la tarjeta OED de arriba no se le
           dibuja, el Centro de Cobros le da un 403 y el único enlace a la lista vivía DENTRO de esa
           pantalla: una puerta que existe y a la que no se llega, que es el mismo defecto que un
           botón que lleva a un 403, contado al revés (revisión CODEX, ronda 3).

           SOLO para quien no llega al Centro de Cobros, y por eso cuelga del `else` de
           `puedeVerCobros` (ver `cargarCobros`): quien entra ahí ya tiene la puerta en su sitio
           —esa pantalla MIDE y la lista ACTÚA—, y una segunda aquí sería una tarjeta más en una
           rejilla de ocho para la misma cosa. Y por eso tampoco se le pregunta al servidor: la
           respuesta no cambiaría lo que se pinta.

           Y se dibuja SI Y SOLO SI el servidor dice que esa persona entra, con la MISMA pregunta
           que la barrera de la ruta y que el enlace del Centro de Cobros, para que ninguna de las
           tres pueda decir algo distinto de las otras (regla de pantalla de dirección, 05/10/2026).

           Lo que esto NO cierra, y queda dicho: el Cuadro de mandos cuelga del menú efectivo de
           Mongo (`RoutesUtils.tieneAcceso`), así que a un gestor que no lo tenga en su menú esta
           puerta tampoco le aparece. Eso se arregla en el menú, que es dato y no código. -->
      <f7-link v-if="puedeEntrarTrabajoHoy" href="/dashboard/cobros/mi-trabajo/" class="dashboard-card active" style="border-left: 4px solid #534AB7">
        <div class="card-icon" style="background: #EEEDFE">
          <f7-icon f7="checkmark_square" style="color: #534AB7; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">MI TRABAJO DE HOY</p>
        <p class="card-subtitle">Gestión de cobro</p>
        <p class="card-badge">Tu lista diaria de cobro</p>
      </f7-link>
      <div class="dashboard-card disabled" style="border-left: 4px solid #BA7517">
        <div class="card-icon" style="background: #FAEEDA">
          <f7-icon f7="doc_text_fill" style="color: #BA7517; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">OEE</p>
        <p class="card-subtitle">Facturación</p>
        <p class="card-badge">Próximamente</p>
      </div>
      <!-- CRM NEW: acceso gateado POR ROL (dirección: DIRECTOR/DTYCAL por defecto, configurable
           por VUE_APP_CRM_NEW_ACCESO_*), fail-closed. En dev se muestra siempre (nadie tiene
           DIRECTOR en dev). El menú oficial NO se toca: patrón calcado a la tarjeta LEARNING.
           Revertir = borrar esta tarjeta + mostrarCrmNew + volver abrirCrmNew a su forma dev-only. -->
      <div v-if="mostrarCrmNew" class="dashboard-card active" style="border-left: 4px solid #2f74f0" @click="abrirCrmNew">
        <div class="card-icon" style="background: #eef5ff">
          <f7-icon f7="briefcase_fill" style="color: #2f74f0; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">CRM NEW</p>
        <p class="card-subtitle">Comercial</p>
      </div>
      <!-- FORMACION: acceso a SIMECAL LEARNING gateado POR ROL (dirección: DIRECTOR/DTYCAL/
           FORMACION_ADMIN por defecto, configurable por VUE_APP_FORMACION_ACCESO_*), fail-closed.
           En dev se muestra siempre (nadie tiene DIRECTOR en dev). El menú oficial NO se toca:
           lo integra Rubén al validar. Revertir = borrar esta tarjeta + mostrarLearning +
           el método abrirFormacionNew del <script>. -->
      <div v-if="mostrarLearning" class="dashboard-card active" style="border-left: 4px solid #059669" @click="abrirFormacionNew">
        <div class="card-icon" style="background: #ecfdf5">
          <f7-icon f7="book_fill" style="color: #059669; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">LEARNING</p>
        <p class="card-subtitle">Formación</p>
        <p class="card-badge" style="color:#b7791f;background:#fbf0d9;border-radius:999px;padding:1px 8px;font-weight:600">VALIDACIÓN</p>
      </div>
    </div>
  </f7-page>
</template>
<style scoped>
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 16px;
  padding: 16px;
}
.dashboard-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  padding: 20px;
  text-align: center;
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dashboard-card.active {
  cursor: pointer;
}
.dashboard-card.active:active {
  transform: scale(0.97);
}
.dashboard-card.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}
.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a2744;
  margin: 0;
}
.card-subtitle {
  font-size: 11px;
  color: #7c8db0;
  margin: 2px 0 0;
}
.card-badge {
  font-size: 10px;
  margin-top: 8px;
  color: #999;
}
/* #1080 · por qué está en gris una tarjeta, pegado a la insignia. */
.card-motivo {
  font-size: 10px;
  margin: 2px 0 0;
  color: #999;
}
/* #187 · la cifra de la tarjeta OED. Mismo sitio que ocupaba el «Próximamente». */
.card-cifra {
  font-size: 16px;
  font-weight: 700;
  color: #1a2744;
  margin: 6px 0 0;
}

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; }
</style>
<script>
import SelloDatos from '../../components/SelloDatos.vue';
import PermisosFacturacion from './permisos-facturacion.js';
import PermisosCobros from './permisos-cobros.js';
import FactCobro from '../../js/db/FactCobro.js';
import UsuarioActualizado from '../../js/usuarioActualizado.js';
import RoutesUtils from '../../js/RoutesUtils.js';
import { ROLES as ROLES_GASTOS } from '../gastos/routes.js';
// isDev es compartido por las tarjetas CRM NEW y LEARNING (ambas visibles siempre en dev,
// gateadas por rol en prod). Revertir CRM NEW = borrar su tarjeta + mostrarCrmNew + volver
// abrirCrmNew a su forma dev-only (ver historial: bloque "CRM-NEW-DEV" original).
export default {
  components: { SelloDatos },
  data() {
    return {
      isDev: process.env.NODE_ENV === 'development',
      // FACT-COBRO: si se ve la tarjeta FACTURACIÓN (D-ROL: ADMIN y DIRECTOR). Empieza en `false`
      // y la contesta `cargarPermisoFacturacion()` cuando llega el usuario de esta carga.
      puedeVerFacturacion: false,
      // #187: si se ve la tarjeta OED · Cobros (D-COB-5, otra lista: `permisos-cobros.js`).
      puedeVerCobros: false,
      // Gastos: si `/gastos/` está en el menú del usuario de esta carga (`cargarPermisoGastos`).
      puedeVerGastos: false,
      // La cifra de esa tarjeta y cuántos documentos la forman. `null` mientras no haya llegado o
      // si la petición falla: nunca un cero, que se leería como «no hay nada pendiente».
      pendienteCobros: null,
      documentosCobros: null,
      // #190 · si se le dibuja la puerta a «Mi trabajo de hoy». La contesta el SERVIDOR y solo se
      // le pregunta a quien no llega al Centro de Cobros (ver `cargarCobros`). Arranca en `false`
      // y se queda en `false` si la pregunta falla — fail-closed, igual que la barrera de esa ruta.
      puedeEntrarTrabajoHoy: false,
    };
  },
  // FACT-COBRO: el permiso de la tarjeta FACTURACIÓN se resuelve aquí y no en un `computed`.
  //
  // POR QUÉ NO UN `computed` (revisión del PR #1742, ronda 2): un `computed` que solo lee
  // `localStorage` no depende de nada reactivo, así que Vue lo calcula la primera vez que se
  // pinta y no lo vuelve a calcular nunca. Al recargar con sesión abierta esa primera vez cae
  // antes de que termine el `Usuario.me()` que lanza `app.vue`, o sea con los roles de la sesión
  // anterior: a quien acabaran de ascender a DIRECTOR no se le enseñaría la tarjeta, y a quien le
  // hubieran retirado el rol se le seguiría enseñando hasta volver a entrar.
  //
  // Así que se pregunta por el usuario de ESTA carga —la misma promesa que espera la ruta de la
  // pestaña (`barreraUsuarioActualizado.js`)— y el resultado va a `data`, que sí es reactivo.
  // Fail-closed mientras llega y si falla: una tarjeta que no aparece es coherente con una
  // pestaña en la que la ruta tampoco habría dejado entrar.
  //
  // El resto de la rejilla no se toca: las tarjetas CRM NEW y LEARNING tienen su propio criterio
  // —en dev se ven siempre— y cambiarlas no es de esta tarea.
  created() {
    this.cargarPermisoFacturacion();
    this.cargarCobros();
    this.cargarPermisoGastos();
  },
  computed: {
    // CRM NEW: visibilidad de la tarjeta CRM NEW. Fail-closed: sin usuario o sin rol de la
    // lista, no se ve. Interruptor general y roles configurables sin recompilar
    // (VUE_APP_CRM_NEW_ACCESO_HABILITADO / VUE_APP_CRM_NEW_ACCESO_ROLES). En dev se muestra
    // siempre (facilita pruebas: en dev nadie tiene DIRECTOR asignado). Patrón calcado a
    // mostrarLearning().
    mostrarCrmNew() {
      const habilitado = (process.env.VUE_APP_CRM_NEW_ACCESO_HABILITADO || 'true') !== 'false';
      if (!habilitado) return false;
      if (this.isDev) return true;
      const rolesAcceso = (process.env.VUE_APP_CRM_NEW_ACCESO_ROLES || 'ADMIN,DIRECTOR,DTYCAL')
        .split(',')
        .map((r) => r.trim())
        .filter(Boolean);
      let user = null;
      try {
        user = JSON.parse(localStorage.getItem('user') || 'null');
      } catch (e) {
        return false;
      }
      const rolesUsuario = (user && user.roles) || [];
      return rolesAcceso.some((r) => rolesUsuario.indexOf(r) > -1);
    },
    // FORMACION: visibilidad de la tarjeta LEARNING. Fail-closed: sin usuario o sin rol de
    // la lista, no se ve. Interruptor general y roles configurables sin recompilar
    // (VUE_APP_FORMACION_ACCESO_HABILITADO / VUE_APP_FORMACION_ACCESO_ROLES). En dev se
    // muestra siempre (facilita pruebas: en dev nadie tiene DIRECTOR asignado).
    mostrarLearning() {
      const habilitado = (process.env.VUE_APP_FORMACION_ACCESO_HABILITADO || 'true') !== 'false';
      if (!habilitado) return false;
      if (this.isDev) return true;
      const rolesAcceso = (process.env.VUE_APP_FORMACION_ACCESO_ROLES || 'DIRECTOR,DTYCAL,FORMACION_ADMIN')
        .split(',')
        .map((r) => r.trim())
        .filter(Boolean);
      let user = null;
      try {
        user = JSON.parse(localStorage.getItem('user') || 'null');
      } catch (e) {
        return false;
      }
      const rolesUsuario = (user && user.roles) || [];
      return rolesAcceso.some((r) => rolesUsuario.indexOf(r) > -1);
    },
  },
  methods: {
    // FACT-COBRO: pregunta por la tarjeta FACTURACIÓN con el usuario de esta carga. Sin excepción
    // para `isDev`, al revés que CRM NEW y LEARNING: aquí la restricción es el requisito, y si en
    // dev se viera siempre no habría forma de comprobar que a los demás roles no se les enseña.
    cargarPermisoFacturacion() {
      const self = this;
      UsuarioActualizado.esperar().then(function(usuario) {
        self.puedeVerFacturacion = PermisosFacturacion.verPestana(usuario);
      }).catch(function() {
        // Sin usuario fresco no hay permiso que valga: es la misma regla que aplica la barrera de
        // ruta, que en ese caso enseña «sesión no disponible» en vez de la pantalla.
        self.puedeVerFacturacion = false;
      });
    },
    // Gastos: la misma pregunta que hace la ruta `/gastos/` (`RoutesUtils.checkPermission` →
    // `tieneAcceso`, con el menú de Mongo), hecha con el usuario de ESTA carga y fail-closed.
    cargarPermisoGastos() {
      const self = this;
      UsuarioActualizado.esperar().then(function(usuario) {
        // El segundo argumento es la lista de roles que admite la RUTA (su repliegue mientras no hay
        // menú), no los del usuario: con los del usuario entraría cualquiera, CLIENTE incluido.
        self.puedeVerGastos = !!usuario && RoutesUtils.tieneAcceso('/gastos/', ROLES_GASTOS);
      }).catch(function() {
        self.puedeVerGastos = false;
      });
    },
    // #187 · la tarjeta OED · Cobros: primero el permiso con el usuario de ESTA carga —mismo
    // criterio y misma promesa que la tarjeta FACTURACIÓN— y, solo si se ve, la cifra.
    //
    // Solo si se ve, y es importante: pedir el resumen a quien no entra sería una petición que el
    // servidor contesta con la cartera recortada de alguien que no va a mirarla, en la carga del
    // Cuadro de mandos de todo el mundo.
    //
    // Si la cifra falla, la tarjeta se queda sin número pero se sigue pudiendo abrir: el sitio
    // donde se explica qué pasa es la pantalla, no una rejilla de ocho tarjetas.
    //
    // #190 · Y QUIEN NO LA VE pasa por la otra rama: se le pregunta al servidor si entra en «Mi
    // trabajo de hoy», que es la puerta que a esa persona no le dibuja nadie más. Es una sola
    // decisión con dos salidas y no dos permisos sueltos, para que no pueda pasar que se pinten las
    // dos tarjetas ni ninguna: o ves la cartera —y la puerta a la lista está dentro— o se te
    // ofrece la lista aquí.
    cargarCobros() {
      const self = this;
      UsuarioActualizado.esperar().then(function(usuario) {
        self.puedeVerCobros = PermisosCobros.verCentroCobros(usuario);
        if (!self.puedeVerCobros) return self.resolverTrabajoHoy();
        return FactCobro.resumenCartera().then(function(resumen) {
          if (!resumen) return;
          self.pendienteCobros = self.formatEuros(resumen.pendienteTotal);
          self.documentosCobros = resumen.documentos;
        }).catch(function() {
          self.pendienteCobros = null;
          self.documentosCobros = null;
        });
      }).catch(function() {
        // Sin usuario fresco no hay permiso que valga: misma regla que la tarjeta FACTURACIÓN. Y
        // tampoco se ofrece la lista diaria: ante la duda no se dibuja ninguna de las dos puertas.
        self.puedeVerCobros = false;
        self.puedeEntrarTrabajoHoy = false;
      });
    },
    /**
     * #190 · Si esta persona entra en «Mi trabajo de hoy», preguntado al SERVIDOR.
     *
     * Solo se llama a quien no ve la tarjeta OED · Cobros, que es exactamente quien no tiene
     * ninguna otra puerta a esa pantalla: el enlace vive dentro del Centro de Cobros y a ese no
     * llega. Un gestor de cobro puede estar en ese caso —«gestor» no es un rol, es quien figura
     * como PGC en alguna factura (D-COB-3)— y el servidor le deja entrar (criterio 10).
     *
     * **No se deduce de los roles aquí**, por lo mismo que en el Centro de Cobros y en la barrera
     * de la ruta: es la misma pregunta contestada en un solo sitio, y con un criterio propio esta
     * rejilla acabaría dibujando una puerta que la ruta cierra.
     *
     * **Fail-closed**: una respuesta que falla, vacía o con un `puedeEntrar` que no es el booleano
     * `true` no es un permiso, y la tarjeta no se dibuja. Y no se avisa de nada: una tarjeta que no
     * aparece no promete nada, y un aviso sobre un enlace que esa persona quizá no tiene sería
     * ruido en una rejilla de ocho tarjetas.
     */
    resolverTrabajoHoy() {
      const self = this;
      return FactCobro.accesoTrabajoHoy().then(function(acceso) {
        self.puedeEntrarTrabajoHoy = !!(acceso && acceso.puedeEntrar === true);
      }).catch(function() {
        self.puedeEntrarTrabajoHoy = false;
      });
    },
    // Euros enteros, que es como se leen estas cifras. Un hueco no llega aquí: la tarjeta no
    // escribe nada cuando no hay cifra.
    formatEuros(valor) {
      if (valor === null || valor === undefined || valor === '') return null;
      return Math.round(Number(valor)).toLocaleString('es-ES');
    },
    // CRM NEW: en prod abre /crm-new/ same-origin (misma sesión JWT, sin handoff de token);
    // en dev mantiene el handoff #token= hacia el Vite de :5173. Patrón calcado a
    // abrirFormacionNew().
    abrirCrmNew() {
      if (!this.isDev) {
        // noopener: la pestaña del CRM no debe tener referencia window.opener a la ERP.
        window.open('/crm-new/', '_blank', 'noopener');
        return;
      }
      const session = JSON.parse(localStorage.getItem('session') || 'null');
      const token = session && (session.token || session.access_token);
      const base = process.env.VUE_APP_CRM_NEW_URL || 'http://localhost:5173/crm-new/';
      const url = token ? base + '#token=' + encodeURIComponent(token) : base;
      window.open(url, '_blank', 'noopener');
    },
    // FORMACION: en prod abre /formacion/ same-origin (misma sesión JWT, sin handoff);
    // en dev mantiene el handoff #token= hacia el Vite de :5174 (patrón CRM NEW).
    abrirFormacionNew() {
      if (!this.isDev) {
        // noopener: la pestaña de LEARNING no debe tener referencia window.opener a la ERP.
        window.open('/formacion/', '_blank', 'noopener');
        return;
      }
      const session = JSON.parse(localStorage.getItem('session') || 'null');
      const token = session && (session.token || session.access_token);
      const base = process.env.VUE_APP_FORMACION_NEW_URL || 'http://localhost:5174/formacion/';
      const url = token ? base + '#token=' + encodeURIComponent(token) : base;
      window.open(url, '_blank', 'noopener');
    },
  },
};
</script>
